import { EducationForm } from "src/app/services/apis/web-api-client";

export const EducationForms = [
  { type: EducationForm.FullTime, text: 'Очная' },
  // { type: EducationForm.Mixed, text: 'Очно-заочная' },
  { type: EducationForm.Distant, text: 'Онлайн' },
  // { type: EducationForm.DOTDistant, text: 'Заочная с применением ДОТ' }
];


export function GetEducationForms(item: EducationForm) {
  return EducationForms.find(x => x.type === item).text || 'Не указано'
};
